import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { useGetLeadSourcesQuery } from "@/redux/rtk/features/leadSource/leadSourceApi";
import { useBulkUpdateLeadMutation } from "@/redux/rtk/features/leads/leadsApi";
import { Button, Form, Select } from "antd";
import { useTranslation } from "react-i18next";

export default function BulkUpdateLeadSource({ selectedRowKeys, onClose, clearSelection }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [bulkUpdateLead, { isLoading }] = useBulkUpdateLeadMutation();

    const { data: leadSourceList, isLoading: leadSourceLoading } = useGetLeadSourcesQuery();

    const onFinish = async (values) => {
        const payload = {
            ids: selectedRowKeys,
            leadSourceId: values.leadSourceId,
        };
        const resp = await bulkUpdateLead(payload);
        if (resp.data) {
            form.resetFields();
            clearSelection();
            onClose();
        }
    };

    return (
        <UserPrivateComponent permission="update-lead">
            <div className="mt-5">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    className="flex flex-col gap-4">
                    <Form.Item
                        label={t("lead.leadSource")}
                        name="leadSourceId"
                        rules={[{ required: true, message: t("lead.leadSourceRequired") }]}>
                        <Select
                            loading={leadSourceLoading}
                            placeholder={t("lead.selectLeadSource")}
                            showSearch
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }>
                            {leadSourceList?.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                    {item.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <div className="flex justify-end gap-2">
                        <Button onClick={onClose}>{t("common.cancel")}</Button>
                        <Button type="primary" htmlType="submit" loading={isLoading}>
                            {t("common.update")}
                        </Button>
                    </div>
                </Form>
            </div>
        </UserPrivateComponent>
    );
}
